'use client';

import * as React from 'react';
import { Player, PlayerVerificationStatus } from '@alien-platform/bo-core';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';

export function PlayerSettingsTab({ playerData }: { playerData: Player | undefined }): React.JSX.Element {
  return (
    <Stack direction="column">
      {!playerData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <Typography variant="h6">General Settings</Typography>
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <Box sx={{ width: 1 }}>
              <FormControlLabel control={<Checkbox defaultChecked={playerData.isBlocked} />} label="Ban Player" />
            </Box>
            <Box sx={{ width: 1 }}>
              <FormControlLabel
                control={<Checkbox defaultChecked={playerData.isForceVerification} />}
                label="Forced KYC"
              />
            </Box>
          </Stack>

          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <Box sx={{ width: 1 }}>
              <FormControlLabel control={<Checkbox defaultChecked={playerData.isVerified} />} label="Verified Badge" />
            </Box>
            <Box sx={{ width: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={playerData.kyc?.verifications?.[0]?.status === PlayerVerificationStatus.CONFIRMED}
                  />
                }
                label="Verified KYC"
              />
            </Box>
          </Stack>
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <FormControl fullWidth>
              <InputLabel shrink>Daily Withdraw Requests</InputLabel>
              <OutlinedInput fullWidth />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel shrink>Monthly Withdraw Requests</InputLabel>
              <OutlinedInput fullWidth />
            </FormControl>
          </Stack>
          <Typography variant="h6">Level</Typography>
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <FormControl fullWidth>
              <InputLabel shrink>Tier Level</InputLabel>
              <OutlinedInput fullWidth />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel shrink>Affiliate Class</InputLabel>
              <OutlinedInput fullWidth />
            </FormControl>
          </Stack>
          <Typography variant="h6">Username</Typography>
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <OutlinedInput fullWidth value={playerData.username} disabled />
            <OutlinedInput fullWidth placeholder="Enter new username" />
            <Button variant="contained" sx={{ minWidth: 100 }}>
              Save
            </Button>
          </Stack>
          <Typography variant="h6">Security</Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained">Reset Password</Button>
            <Button variant="contained" color="error">
              Block Player
            </Button>
          </Box>
        </Stack>
      )}
    </Stack>
  );
}
